// Chakra imports
import {
	Flex,
	FormLabel,
	Input,
	InputGroup,
	InputRightElement,
	Text,
	useColorModeValue,
} from '@chakra-ui/react';
// Custom components

export default function Default(props) {
	const { id, label, extra, placeholder, type, mb, unit, ...rest } = props;
	const textColorPrimary = useColorModeValue('gray.900', 'gray.100');

	return (
		<Flex direction='column' mb={mb ? mb : '30px'}>
			<FormLabel
				display='flex'
				ms='10px'
				htmlFor={id}
				fontSize='sm'
				color={textColorPrimary}
				fontWeight='bold'
				_hover={{ cursor: 'pointer' }}
			>
				{label}
				<Text fontSize='sm' fontWeight='400' ms='2px'>
					{extra}
				</Text>
			</FormLabel>
			<InputGroup>
				<Input
					{...rest}
					type={type}
					id={id}
					fontWeight='500'
					variant='main'
					placeholder={placeholder}
					h='44px'
					maxh='44px'
				/>
				{unit && (
					<InputRightElement width='3rem' h='44px' maxh='44px'>
						<Text fontSize='sm' fontWeight='bold' pr={5}>
							{unit}
						</Text>
					</InputRightElement>
				)}
			</InputGroup>
		</Flex>
	);
}
